module.exports = __webpack_public_path__ + "img/lb111.3a23237b.png";